{	
	title: { "en": "Forest explorer",
		"es": "Explorador forestal",
		"pt": "Explorador florestal"},
	map: { "en": "Map",
		"es": "Mapa",
		"pt": "Mapa"},
	search: { "en": "Search",
		"es": "Buscar",
		"pt": "Pesquisar"},
	label: { "en": "Label",	
		"es": "Etiqueta",	
		"pt": "Etiqueta"},
	showmore: { "en": "Show more",	
		"es": "Mostrar más",	
		"pt": "Mostrar mais"},
	all: { "en": "ALL",
		"es": "TODOS",
		"PT": "TODOS"},
	flaglang: { "en": "🇬🇧 EN",
		"es": "🇪🇸 ES"},
	loadingdata: { "en": "Loading data...",
		"es": "Cargando datos...",
		"pt": "Carregando dados..."},
	spain: { "en": "Spain",
		"es": "España"},
	portugal: { "en": "Portugal",
		"es": "Portugal"},
	local: { "en": "en",
		"es": "es",
		"pt": "pt"},
	homelocrel: { "en": "..",
		"es": "../es"},
	back:	{ "en": "Go back",
		"es": "Volver" },
	menu: { "en": "Menu",
		"es": "Menú"},		
	iconexp: { "en": "iconfull_en.png",
		"es": "iconfull_es.png",
		"pt": "iconfull_es.png"},		
	zoomin: { "en": "Zoom in",
		"es": "Más zoom",
		"pt": "Aproximar"},
	zoomout: { "en": "Zoom out",
		"es": "Menos zoom",
		"pt": "Afastar"},
	mylocation: { "en": "My location",
		"es": "Mi localización",
		"pt": "Minha localização"},
	close: { "en": "Close",
		"es": "Cerrar",
		"pt": "Fechar"},
		
	
	source: { "en": "source",
		"es": "fuente"},
	urlifn2: { "en": '<a href="https://www.miteco.gob.es/es/biodiversidad/servicios/banco-datos-naturaleza/informacion-disponible/ifn2.html" target="_blank">NFI2</a>',
		"es": '<a href="https://www.miteco.gob.es/es/biodiversidad/servicios/banco-datos-naturaleza/informacion-disponible/ifn2.html" target="_blank">IFN2</a>'},
	urlifn3: { "en": '<a href="https://www.miteco.gob.es/es/biodiversidad/servicios/banco-datos-naturaleza/informacion-disponible/ifn3.html" target="_blank">NFI3</a>',
		"es": '<a href="https://www.miteco.gob.es/es/biodiversidad/servicios/banco-datos-naturaleza/informacion-disponible/ifn3.html" target="_blank">IFN3</a>'},
	sourceifn2: { "en": 'source: <a href="https://www.miteco.gob.es/es/biodiversidad/servicios/banco-datos-naturaleza/informacion-disponible/ifn2.html" target="_blank">NFI2</a>',
		"es": 'fuente: <a href="https://www.miteco.gob.es/es/biodiversidad/servicios/banco-datos-naturaleza/informacion-disponible/ifn2.html target="_blank"">IFN2</a>'},
	sourceifn3: { "en": 'source: <a href="https://www.miteco.gob.es/es/biodiversidad/servicios/banco-datos-naturaleza/informacion-disponible/ifn3.html" target="_blank">NFI3</a>',
		"es": 'fuente: <a href="https://www.miteco.gob.es/es/biodiversidad/servicios/banco-datos-naturaleza/informacion-disponible/ifn3.html" target="_blank">IFN3</a>'},
	sourceifnPT: { "en": 'source: <a href="https://www.icnf.pt/noticias/inventarioflorestalnacional" target="_blank">NFI6-PT</a>',
		"es": 'fuente: <a href="https://www.icnf.pt/noticias/inventarioflorestalnacional" target="_blank">IFN6-PT</a>'},	
	sourcemfe50: { "en": 'source: <a href="https://www.miteco.gob.es/es/biodiversidad/servicios/banco-datos-naturaleza/informacion-disponible/mfe50.html" target="_blank">MFE50</a>',
		"es": 'fuente: <a href="https://www.miteco.gob.es/es/biodiversidad/servicios/banco-datos-naturaleza/informacion-disponible/mfe50.html" target="_blank">MFE50</a>'},		
	sourcecos2018: { "en": 'source: <a href="https://www.dgterritorio.gov.pt/Carta-de-Uso-e-Ocupacao-do-Solo-para-2018" target="_blank">COS2018</a>',
		"es": 'fuente: <a href="https://www.dgterritorio.gov.pt/Carta-de-Uso-e-Ocupacao-do-Solo-para-2018" target="_blank">COS2018</a>'},
	ifnversion: { "en": "NFI edition",
		"es": "Edición del IFN"},
	IFN: { "en": "NFI",
		"es": "IFN"},
	IFN2: { "en": "NFI2",
		"es": "IFN2"},
	IFN3: { "en": "NFI3",
		"es": "IFN3"},
	IFN4: { "en": "NFI4",
		"es": "IFN4"},
	
		
	toastIFN2: { "en": "In NFI2, the plots in Asturias, Cantabria, Navarra, and the Balearic Islands are not geolocated.",
		"es": "En el IFN2, las parcelas de Asturias, Cantabria, Navarra y Baleares no están geolocalizadas."},
	

	errorEndpointTitle: { "en": "Data provider not accessible",
		"es": "No puede accederse al proveedor de datos",
		"pt": "Provedor de dados não acessível"},
	errorEndpointText: { "en": "The data provider is temporarily not accessible. \
			We apologize for the inconvenience and recommend to try later.",
		"es": "El proveedor de datos está temporalmente no disponible. \
			Lamentamos este inconveniente y recomendamos que pruebe más tarde.",
		"pt": "Servidor de dados está temporariamente indisponível. \
			Pedimos desculpas pelo transtorno e recomendamos que tente mais tarde."},	
		
	
	starting: { "en": "Starting Forest explorer",
		"es": "Iniciando el Explorador forestal",
		"pt": "Iniciando o Explorador florestal"},
	confdata: { "en": "Configuring data services",
		"es": "Configurando los servicios de datos",
		"pt": "Configurando serviços de dados"},
	conftaxon: { "en": "Extracting taxonomic data",
		"es": "Extrayendo datos de taxones",
		"pt": "Extraindo dados de taxone"},
	confreg: { "en": "Extracting region data",
		"es": "Extrayendo datos de regiones",
		"pt": "Extraindo dados de regiões"},
		

	spinnerInit: { "en": "Initializing...",
		"es": "Inicializando...",
		"pt": "Inicializando..."},
	spinnerData: { "en": "Retrieving data...",
		"es": "Obteniendo datos...",
		"pt": "Obtendo dados..."},
	spinnerRenderingProvs: { "en": "Rendering provinces...",
		"es": "Pintando provincias...",
		"pt": "Carregando províncias/NUTS..."},
	spinnerRenderingPlots: { "en": "Rendering plots...",
		"es": "Pintando parcelas...",
		"pt": "Carregando parcelas..."},
	spinnerRenderingTrees: { "en": "Rendering trees...",
		"es": "Pintando árboles...",
		"pt": "Carregando árvores..."},
	spinnerRenderingPatches: { "en": "Rendering patches...",
		"es": "Pintando teselas...",
		"pt": "Carregando manchas..."},	
	spinnerLoading: { "en": "Loading data...",
		"es": "Cargando datos..."},
	spinnerInfo: { "en": "We are querying our fancy databases.",
		"es": "Estamos consultando a nuestras molonas bases de datos."},
	
		
		
	ttHome: { "en": "Home",
		"es": "Inicio",
		"pt": "Início"},
	ttExpandForm: { "en": "Expand form",
		"es": "Expandir formulario",
		"pt": "Expandir o formulário"},
	ttCollapseForm: { "en": "Collapse form",
		"es": "Colapsar formulario",
		"pt": "Recolher formulário"},
	ttAddSpeciesfilter: { "en": "Add tree species filter",	
		"es": "Añadir filtro de especie",	
		"pt": "Adicionar filtro de espécies"},
	ttHideSpeciesfilterMenu: { "en": "Hide filter species menu",
		"es": "Esconder menú de filtrar",	
		"pt": "Ocultar filtro de espécies"},
	ttChangeColor: { "en": "Change color",
		"es": "Cambiar color",	
		"pt": "Mudar cor"},
	ttRemoveFilter: { "en": "Remove filter",
		"es": "Quitar filtro",	
		"pt": "Remover filtro"},
	ttSubspecies: { "en": "#subspecies",
		"es": "#subespecies",	
		"pt": "#subespécies"},
	ttTrees: { "en": "#instances in inventory",
		"es": "#ejemplares en inventario",	
		"pt": "#instâncias no inventário"},
	ttExpandSpecies: { "en": "Expand subspecies",
		"es": "Expandir subespecies",
		"pt": "Expandir subespécies"},
	ttCollapseSpecies: { "en": "Collapse subspecies",
		"es": "Colapsar subespecies",
		"pt": "Recolher subespécies"},
			

	plotcolor: { "en": "Plot color",
		"es": "Color de parcela",
		"pt": "Cor da parcela"},
	color0: { "en": "Green",
		"es": "Verde",
		"pt": "Verde"},
	color1: { "en": "Gray",
		"es": "Gris",
		"pt": "Cinzento"},
	color2: { "en": "Blue gray",
		"es": "Gris azulado",
		"pt": "Cinzento azulado"},
	color3: { "en": "Orange",
		"es": "Naranja",
		"pt": "Laranja"},
	color4: { "en": "Blue",
		"es": "Azul",
		"pt": "Azul"},
	color5: { "en": "Pink",
		"es": "Rosa",
		"pt": "Rosa"},
	color6: { "en": "Purple",
		"es": "Violeta",
		"pt": "Roxo"},
	color7: { "en": "Indigo",
		"es": "Añil",
		"pt": "Azul índigo"},
	color8: { "en": "Cyan",
		"es": "Celeste",
		"pt": "Ciano"},
	color9: { "en": "Brown",
		"es": "Marrón",
		"pt": "Castanho"},
						
	
	dataCapture: { "en": "data taken in",
		"es": "toma de datos en",
		"pt": "coleta de dados em"},
	dataCapturefrom: { "en": "data taken from ",
		"es": "toma de datos de ",
		"pt": "coleta de dados de "},
	plotDate: { "en": "capture date",
		"es": "fecha muestreo"},
	dataCaptureto: { "en": " to ",
		"es": " a ",
		"pt": " a "},
		
	
	
	selectLayer: { "en": "Select layer",
		"es": "Seleccionar capa",
		"pt": "Selecione a camada"},
	mapType: { "en": "Map type",
		"es": "Tipo de mapa",
		"pt": "Tipo de mapa"},
	default: { "en": "Default",
		"es": "Predeterminado",
		"pt": "Predeterminado"},
	satellite: { "en": "Satellite",
		"es": "Satélite",
		"pt": "Satélite"},
	mapDetails: { "en": "Map details",
		"es": "Detalles del mapa",
		"pt": "Detalhes do mapa"},
	patches: { "en": "Patches",
		"es": "Teselas",
		"pt": "Manchas"},
	regions: { "en": "Regions",
		"es": "Regiones",
		"pt": "Regiões"},
	municipalities: { "en": "Municipalities",
		"es": "Municipios",
		"pt": "Municípios"},
	plots: { "en": "Plots",	
		"es": "Parcelas",
		"pt": "Parcelas"},
		
	
			
	patch: { "en": "Patch",	
		"es": "Tesela",	
		"pt": "Mancha"},
	provinceof: { "en": "province of",
		"es": "provincia de"},
	soiluse: { "en": "soil use",
		"es": "uso del suelo",
		"pt": "uso do solo"},
	canopycovertrees: { "en": "canopy cover of trees",
		"es": "cabida cubierta arbórea",	
		"pt": "cobertura de copas das árvores"},
	area: { "en": "area",
		"es": "área",	
		"pt": "área"},
	speciesinfo: { "en": "species info",	
		"es": "información de especies",
		"pt": "informação de espécie"},
		
		
	spanishProvince: { "en": "Spanish province",
		"es": "provincia española",
		"pt": "província espanhola"},
	portugueseRegion: { "en": "Portuguese NUTS3 region",
		"es": "región NUTS3 portuguesa",
		"pt": "região NUTS3 portuguesa"},
	treesinv: { "en": "#sampled trees",
		"es": "#árboles muestreados"},
	plotsinv: { "en": "#sampled plots",
		"es": "#parcelas muestreadas"},
	numbertrees: { "en": "#trees",
		"es": "#árboles",
		"pt": "#árvores"},
	basalareaM2: { "en": "basal area (m<sup>2</sup>)",
		"es": "área basimétrica (m<sup>2</sup>)",
		"pt": "área basal (m<sup>2</sup>)"},
	volumewithbarkM3: { "en": "vol. over bark (m<sup>3</sup>)",
		"es": "vol. con corteza (m<sup>3</sup>)",
		"pt": "vol. com casca (m<sup>3</sup>)"},
	volumewithoutbarkM3: { "en": "vol. under bark (m<sup>3</sup>)",
		"es": "vol. sin corteza (m<sup>3</sup>)",
		"pt": "vol. sem casca (m<sup>3</sup>)"},
	volumefirewoodM3: { "en": "vol. firewood (m<sup>3</sup>)",
		"es": "vol. de leña (m<sup>3</sup>)"},
	forestSurfaceHa: { "en": "forest surface (ha)",
		"es": "superficie forestal (ha)"},


	plot: { "en": "Plot",	
		"es": "Parcela",
		"pt": "Parcela"},
	nplots: { "en": "#plots",	
		"es": "#parcelas",
		"pt": "#parcelas"},
	notreedata: { "en": "No tree data",	
		"es": "Sin datos de árboles"},
	otherinvs: { "en": "other inventories",	
		"es": "otros inventarios"},
	numbertreesHA: { "en": "stand dens. (trees/ha)",
		"es": "dens. masa (#árboles/ha)"},
	basalareaM2HA: { "en": "basal area (m<sup>2</sup>/ha)",
		"es": "área basimétrica (m<sup>2</sup>/ha)",
		"pt": "área basal (m<sup>2</sup>/ha)"},
	basalareaM2HAmini: { "en": "basal area (m<sup>2</sup>/ha)",
		"es": "área bas. (m<sup>2</sup>/ha)"},
	volumewithbarkM3HA: { "en": "vol. over bark (m<sup>3</sup>/ha)",
		"es": "vol. con corteza (m<sup>3</sup>/ha)",
		"pt": "vol. com casca (m<sup>3</sup>/ha)"},
	volumewithbarkM3HAmini: { "en": "vol. (OB) (m<sup>3</sup>/ha)",
		"es": "v. con cort. (m<sup>3</sup>/ha)"},
	volumewithoutbarkM3HA: { "en": "vol. under bark (m<sup>3</sup>/ha)",
		"es": "vol. sin corteza (m<sup>3</sup>/ha)",
		"pt": "vol. sem casca (m<sup>3</sup>/ha)"},	
	volumewithoutbarkM3HAmini: { "en": "vol. (UB) (m<sup>3</sup>/ha)",
		"es": "v. sin cort. (m<sup>3</sup>/ha)"},
	sampledtrees: { "en": "#sampled trees",
		"es": "#árboles muestreados"},
	showplots: { "en": "Show plots",
		"es": "Ver parcelas",
		"pt": "Mostrar parcelas"},
	showdashboard: { "en": "Show dashboard",
		"es": "Mostrar dashboard"},
	any: { "en": "any",
		"es": "cualquiera"},


	
	taxonfilter: { "en": "Taxon",	
		"es": "Taxón",
		"pt": "Táxon"},
	filter: { "en": "Filter",	
		"es": "Filtrar",
		"pt": "Filtro"},
	filtering: { "en": "Filtering",	
		"es": "Filtrando",
		"pt": "Filtrando"},
	removefilter: { "en": "Remove filter",	
		"es": "Quitar filtro",
		"pt": "Remover filtro"},
	searchtaxon: { "en": "Search taxon...",	
		"es": "Buscar taxón...",
		"pt": "Pesquisar táxon..."},
	notaxonfound: { "en": "No taxon matched",	
		"es": "No hay taxones que coincidan",
		"pt": "Não há taxa que coincidam"},
	taxonid: { "es": "Taxon with id ",	
		"es": "Taxón con id ",
		"pt": "Táxon com id "},
	nomci: { "en": "Scientific names",	
		"es": "Nombres científicos",
		"pt": "Nomes científicos"},
	tooManyTaxons: { "en": "Filtering too many taxons!",	
		"es": "¡Demasiados filtros de taxones!",
		"pt": "Filtrando demasiados táxons!"},
	taxonAlreadyIncluded: { "en": "Taxon already included.",
		"es": "Taxón ya incluido.",
		"pt": "Táxon já incluído."},
	textTooManySpecies: { "en": "Filtering too many species of trees. Please remove one if you want to set a new filter",	
		"es": "Demasiados filtros de especies de árboles. Elimina uno si quieres poner un nuevo filtro",
		"pt": "Filtrou demasiadas espécies de árvores. Exclua uma se quiser aplicar um novo filtro"},
	species: { "en": "Species",	
		"es": "Especie",
		"pt": "Espécie"},
	genus: { "en": "Genus",	
		"es": "Género",
		"pt": "Género"},
	family: { "en": "Family",	
		"es": "Familia",
		"pt": "Família"},
	class: { "en": "Class",	
		"es": "Clase",
		"pt": "Classe"},
	wikipage: { "en": "Wikipedia page",	
		"es": "Wikipedia",
		"pt": "Wikipedia"},
	treeInitial: { "en": "T",	
		"es": "A",
		"pt": "A"},
	
	plants: { "en": "Plants",
		"es": "Plantas"},
	plotfilter: { "en": "Configure plot filter",	
		"es": "Configura el filtro de parcela"},
	applyfilter: { "en": "Apply filter",
		"es": "Aplicar filtro"},
	resetfilter: { "en": "Reset filter",
		"es": "Resetear filtro"},

		
	
	errorPlotTitle: { "en": "The plot does not exist",
		"es": "No existe la parcela"},
	errorPlotText: { "en": "There is no plot with IRI ",
		"es": "No existe una parcela con IRI "},
	noTreesInPlot: { "en": "No sampled trees in this plot",
		"es": "No se han muestreado árboles en esta parcela"},
	
	
	plotType: { "en": "plot class",
		"es": "clase de parcela"},
	plotexs: { "en": "stock plot",
		"es": "parcela de existencias"},
	plotcomp: { "en": "comparison plot",
		"es": "parcela de comparación"},
	plotifn2: { "en": "NFI2 plot (not comparable)",
		"es": "parcela IFN2 (no comparable)"},
	viewplotifn2: { "en": "View NFI2 plot",
		"es": "Ver parcela IFN2"},
	plotifn3: { "en": "NFI3 plot (not comparable)",
		"es": "parcela IFN3 (no comparable)"},
	viewplotifn3: { "en": "View NFI3 plot",
		"es": "Ver parcela IFN3"},
	viewstockplot: { "en": "View stock plot",
		"es": "Ver parcela de existencias"},
	viewcompplot: { "en": "View comparison plot",
		"es": "Ver parcela de comparación"},
	soilUse: { "en": "soil use",
		"es": "uso del suelo"},
	canopyCover: { "en": "canopy cover",
		"es": "cabida cubierta"},
	plantCover: { "en": "plant cover",
		"es": "cubierta de plantas"},	
	altitude: { "en": "altitude",
		"es": "altitud"},
	province: { "en": "province",
		"es": "provincia"},
	municipality: { "en": "municipality",
		"es": "municipio"},
	charttable: { "en": "Chart/Table",
		"es": "Figura/Tabla"},
	

	tree: { "en": "Tree",	
		"es": "Árbol",
		"pt": "Árvore"},
	treemin: { "en": "tree",	
		"es": "árbol",
		"pt": "árvore"},
	trees: { "en": "Trees",	
		"es": "Árboles",
		"pt": "Árvores"},	
	ntree: { "en": "#tree",	
		"es": "#árbol",
		"pt": "#árvore"},
	order: { "en": "order",	
		"es": "orden"},
	speciesmin: { "en": "species",
		"es": "especie",
		"pt": "espécie"},
	height: { "en": "height",	
		"es": "altura",
		"pt": "altura"},
	heightm: { "en": "height (m)",	
		"es": "altura (m)",
		"pt": "altura (m)"},
	diameter: { "en": "diameter",	
		"es": "diámetro",
		"pt": "diâmetro"},
	diametermm: { "en": "diameter (mm)",	
		"es": "diámetro (mm)",
		"pt": "diâmetro (mm)"},
	basalareaTree: { "en": "basal area (m<sup>2</sup>)",
		"es": "área bas. (m<sup>2</sup>)",
		"pt": "área basal (m<sup>2</sup>)"},
	volumewithbarkTree: { "en": "vol. (OB) (dm<sup>3</sup>)",
		"es": "v. con cort. (dm<sup>3</sup>)",
		"pt": "v. com casca (dm<sup>3</sup>)"},
	volumewithoutbarkTree: { "en": "vol. (UB) (dm<sup>3</sup>)",
		"es": "v. sin cort. (dm<sup>3</sup>)",
		"pt": "v. sem casca (dm<sup>3</sup>)"},
	volumefirewoodTree: { "en": "vol. firewood (dm<sup>3</sup>)",
		"es": "v. leña (dm<sup>3</sup>)"},
	treedensity: { "en": "stand density",
		"es": "densidad masa"},	
	basalarea: { "en": "basal area",
		"es": "área basimétrica",
		"pt": "área basal"},
	volumewithbark: { "en": "vol. over bark",
		"es": "vol. con corteza",
		"pt": "vol. com casca"},
	volumewithoutbark: { "en": "vol. under bark",
		"es": "vol. sin corteza",
		"pt": "vol. sem casca"},
	treesHA: { "en": "trees/ha",
		"es": "árboles/ha",
		"pt": "árvores/ha "},
	treeData: { "en": "Tree data",
		"es": "Datos de árboles"},
	stockSpeciesInfo: { "en": "Stock by species",
		"es": "Existencias por especie"},
	dcSpeciesInfo: { "en": "Stock by diameter class",
		"es": "Existencias por clase diamétrica"},
	show: { "en": "Show",
		"es": "Mostrar"},
	hide: { "en": "Hide",
		"es": "Esconder"},
	
	
	
	download: { "en": "Download",
		"es": "Descargar"},
	downloadData: { "en": "Download data",
		"es": "Descargar datos",
		"pt": "Baixar dados"},
	downloadPolygonToast: { "en": "Draw a polygon for the data download",
		"es": "Dibuja un polígono para la descarga de datos"},
	cancel:  { "en": "Cancel",	
		"es": "Cancelar" },
	cancelPolygon:  { "en": "Cancel polygon",	
		"es": "Cancelar polígono" },
	finish:  { "en": "Finish",	
		"es": "Terminar" },
	finishPolygon:  { "en": "Finish polygon",	
		"es": "Terminar polígono" },
	deleteLastPoint:  { "en": "Delete last point",	
		"es": "Borrar último punto" },
	deleteLastPointDrawn:  { "en": "Delete last point drawn",	
		"es": "Borrar último punto dibujado" },
	startPolygon: { "en": "Click to start drawing the polygon.",
		"es": "Clica para empezar a dibujar el polígono."}, 
	contPolygon: { "en": "Click to continue drawing the polygon.",
		"es": "Clica para continuar dibujando el polígono."},
	endPolygon: { "en": "Click first point to close the polygon.",
		"es": "Clica el primer punto para cerrar el polígono."},
	errorPolygon: { "en": "<strong>Error:</strong> polygon lines cannot cross!",
		"es": "<strong>Error:</strong> ¡no pueden cruzarse las líneas del polígono!"},
	toastDownload: { "en": "Wait until all data has been retrieved.",
		"es": "Espera a que acabe de recuperar los datos.",
		"pt": "Aguarde a conclusão da recuperação dos dados."},
	downloadMessage: { "en": "You will retrieve data within the polygon you have just drawn.",
		"es": "Obtendrás los datos en el polígono que acabas de dibujar."},
	downloadMessagePrev: { "en": "You will retrieve data within the currently visible area of the map:",
		"es": "Obtendrás los datos de la zona visible del mapa:",
		"pt": "Você obterá os dados da área visível do mapa:"},	
	cornerNW: { "en": "NW corner (WGS 84):",
		"es": "Esquina NO (WGS 84):"},
	cornerSE: { "en": "SE corner (WGS 84):",
		"es": "Esquina SE (WGS 84):"},
	zoomLevel: { "en": "Zoom level:",
		"es": "Nivel de zoom:"},	
	downloadIFN: { "en": "Choose which Spanish inventory edition(s):",
		"es": "Elige qué edición(es) del inventario español:"},
	downloadNoIFN: { "en": "No inventory edition!",
		"es": "¡No hay edición de inventario!"},
	downloadNothing: { "en": "Nothing to download!",
		"es": "¡No hay nada que descargar!"},
	downloadChoices: { "en": "Choose what to download:",
		"es": "Elige qué quieres descargar:"},
	checkPlots: { "en": "Inventory plots (NFI3-SP)",
		"es": "Parcelas del inventario (IFN3-ES)"},
	checkTrees: { "en": "Inventory trees (NFI3-SP)",
		"es": "Pies mayores del inventario (NFI3-ES)"},
	checkRegions: { "en": "Regional inventory data (NFI3-SP & NFI6-PT)",
		"es": "Datos del inventario por regiones (IFN3-ES & IFN6-PT)"},
	checkPatches: { "en": "Land cover patches (MFE50-SP & COS2018-PT)",
		"es": "Teselas del mapa forestal (MFE50-ES & COS2018-PT)"},
	downloadFormatChoose: { "en": "Choose your preferred data format:",
		"es": "Elige el formato de datos:"},
	downloadNoFormat: { "en": "No format selected!",
		"es": "¡No hay formato seleccionado!"},	
	downloadingPlots: { "en": "Downloading plots",
		"es": "Descargando parcelas"},
	plotsDownloaded: { "en": "Plots downloaded",
		"es": "Parcelas descargadas"},
	noPlotsDownloaded: { "en": "No plots to download",
		"es": "No había parcelas para descargar"},
	downloadingTrees: { "en": "Downloading trees",
		"es": "Descargando árboles"},
	treesDownloaded: { "en": "Trees downloaded",
		"es": "Árboles descargados"},
	noTreesDownloaded: { "en": "No trees to download",
		"es": "No había árboles para descargar"},
	downloadingRegions: { "en": "Downloading regions",
		"es": "Descargando Regiones"},
	regionsDownloaded: { "en": "Regions downloaded",
		"es": "Regiones descargadas"},
	downloadingPatches: { "en": "Downloading patches",
		"es": "Descargando teselas"},
	patchesDownloaded: { "en": "Patches downloaded",
		"es": "Teselas descargadas"},
	noPatchesDownloaded: { "en": "No patches to download",
		"es": "No había teselas para descargar"},
	downloadSuccess: { "en": "Download successful",
		"es": "Descarga de datos exitosa"},
	wktTooLongForExcel: { "en": "wkt too long for Excel, use other data format",
		"es": "wkt demasiado grande para Excel, usa otro formato de datos"},
	plotsFile: { "en": "plots",
		"es": "parcelas"},
	infoplotsFile: { "en": "plots_infoSpecies",
		"es": "parcelas_infoEspecies"},
	treesFile: { "en": "trees",
		"es": "arboles"},
	regionsFile: { "en": "regions",
		"es": "regiones"},
	inforegionsFile: { "en": "regions_infoSpecies",
		"es": "regiones_infoEspecies"},
	patchesFile: { "en": "patches",
		"es": "teselas"},
	infopatchesFile: { "en": "patches_infoSpecies",
		"es": "teselas_infoEspecies"},		
	downloadFile: { "en": "forestExplorer",
		"es": "exploradorForestal"},
	

	searchplace: { "en": "Search place...",	
		"es": "Buscar lugar...",	
		"pt": "Pesquisar lugar..."},
	noplacesfound: { "en": "No places matched",	
		"es": "No hay lugares que coincidan",	
		"pt": "Nenhum lugar encontrado"},
	population: { "en": "Population",
		"es": "Población",
		"pt": "População"},
	PPLC: { "en": "Capital of a country",
		"es": "Capital de país",
		"pt": "Capital de país"},
	PPLA: { "en": "Seat of an autonomous region",
		"es": "Capital de comunidad autónoma",
		"pt": "Capital de uma região autónoma"},
	PPLA2: { "en": "Seat of a province",
		"es": "Capital de provincia",
		"pt": "Capital de uma província"},
	PPLA3: { "en": "Municipality",
		"es": "Municipio",
		"pt": "Município"},
	PPLA4: { "en": "Populated place",
		"es": "Población",
		"pt": "Povoação"},
	PPL: { "en": "Populated place",
		"es": "Población",
		"pt": "Povoação"},
	FRST: { "en": "Forest",
		"es": "Bosque",
		"pt": "Floresta"},
	HLL: { "en": "Hill",
		"es": "Cerro",
		"pt": "Colina"},
	HLLS: { "en": "Hills",
		"es": "Cerros",
		"pt": "Colinas"},
	MT: { "en": "Mountain",
		"es": "Montaña",
		"pt": "Montanha"},
	MTS: { "en": "Mountains",
		"es": "Montañas",
		"pt": "Montanhas"},
	PRK: { "en": "Park",
		"es": "Parque",
		"pt": "Parque"},
	RDGE: { "en": "Ridge",
		"es": "Sierra",
		"pt": "Cume"},
	RES: { "en": "Reserve",
		"es": "Reserva",
		"pt": "Reserva"},
	RESF: { "en": "Forest reserve",
		"es": "Reserva forestal",
		"pt": "Reserva florestal"},
	RESN: { "en": "Nature reserve",
		"es": "Reserva natural",
		"pt": "Reserva natural"},
	RESW: { "en": "Wildlife reserve",
		"es": "Reserva natural",
		"pt": "Reserva natural"},
	VAL: { "en": "Valley",
		"es": "Valle",
		"pt": "Vale"},
	VALG: { "en": "Hanging valley",
		"es": "Valle glaciar",
		"pt": "Vale glaciar"},
		


	questtext: { "en": "Could you take a moment<br>to answer a short questionnaire<br>to help us improve?",
		"es": "¿Podrías tomarte un momento<br>para responder un breve cuestionario<br>y ayudarnos a mejorar?"},
	questurl: { "en": "https://docs.google.com/forms/d/e/1FAIpQLSd3csvRFyVK4cqSVXEYJD3hTsWi1NgV2MwwcKmj-RkFbnkbEQ/viewform?usp=header",
		"es": "https://docs.google.com/forms/d/e/1FAIpQLSenKYu8H6yap5KFTJWSt4ZP2_kcTZNvQtEhrcCHBT5-YupAiw/viewform?usp=header"},
	yes: { "en": "Yes",
		"es": "Sí",
		"pt": "Sim"},
	no: { "en": "No",
		"es": "No",
		"pt": "Não"},
	later: { "en": "Maybe later",
		"es": "Más tarde",
		"pt": "Talvez mais tarde"},
		
		
	
	tour: { "en": "Tour",
		"es": "Tour"},
	tourTitle0: { "en": "Welcome to Forest Explorer!",
		"es": "¡Bienvenido al Explorador Forestal!"},
	tourText0: { "en": "This is a web application for browsing official forestry data from Spain and Portugal.<br>Let's review the map controls.<br><br><i>You can exit this tour at any time by pushing the 'X'.</i>",
		"es": " Esta aplicación web permite explorar datos forestales oficiales de España y Portugal.<br>Empecemos revisando los controles.<br><br><i>Puedes salir de este tour en cualquier momento pulsando la 'X'.</i>"},
	tourTitle1: { "en": "The map",
		"es": "El mapa"},
	tourText1: { "en": "Forestry data is presented in an interactive map that you can control.<br>Use the touchscreen (or the mouse in PCs) for panning and zooming the map.",
		"es": "Los datos forestales se presentan en un mapa interactivo por el que puedes navegar.<br>Usa la pantalla táctil (o el ratón si es un PC) para mover el mapa o para hacer zoom."},
	tourTitle2: { "en": "Zoom buttons",
		"es": "Botones de zoom"},
	tourText2: { "en": "You can also use these buttons for zooming in or out.",
		"es": "También puedes usar estos botones para controlar el nivel de zoom."},
	tourTitle3: { "en": "My location",
		"es": "Mi localización"},
	tourText3: { "en": "Push this button to center the map in your current location. Please note that you need to grant permission to your browser.<br>In case of success, a blue dot will mark your location in the map (precision can vary).<br>Push the button again to remove the blue dot.",
		"es": "Pulsa este botón para centrar el mapa en tu posición actual. Ten en cuenta que necesitas dar permiso al navegador para obtener tu posición. En caso de éxito, un punto azul marcará tu posición en el mapa (la precisión puede variar).<br>Pulsa de nuevo el botón para esconder el punto azul."},	
	tourText3a: { "en": "Push this button to revisit this tour.",
		"es": "Pulsa este botón para volver a hacer este tour."},
	tourTitle4: { "en": "Download data",
		"es": "Descarga de datos"},
	tourText4: { "en": "Draw a polygon and download the forestry data inside it.",
		"es": "Dibuja un polígono para descargar los datos forestales contenidos."},
	tourTitle5: { "en": "Customize the map",
		"es": "Configura el mapa"},
	tourText5: { "en": "Select the map type, show/hide plots and choose which map details to show.",
		"es": "Selecciona el tipo de mapa, muestra/esconde parcelas y elige qué detalles del mapa mostrar."},
	tourTitle6: { "en": "Search place",
		"es": "Buscar lugar"},
	tourText6: { "en": "Center the map in a specific a place by pushing this button and typing its name.",
		"es": "Centra el mapa en el lugar deseado tras pulsar este botón y teclear su nombre."},		
	tourTitle7: { "en": "IFN version",
		"es": "Edición del IFN"},
	tourText7: { "en": "Select the desired version of the Spanish National Forestry Inventory (IFN).<br><br><i>IFN4 will be available very soon.</i>",
		"es": "Selecciona la edición preferida del Inventario Forestal Nacional español (IFN).<br><br><i>IFN4 estará disponible muy pronto.</i>"},
	tourTitle8: { "en": "Filter taxon",
		"es": "Filtrar taxón"},
	tourText8: { "en": "Filter forestry data in the map by taxon.",
		"es": "Filtra los datos forestales en el mapa por taxón."},
	tourTitle9: { "en": "Taxa names",
		"es": "Nombres de taxones"},
	tourText9: { "en": "Toggle button to choose between scientific or vulgar taxon names.",
		"es": "Botón para elegir entre nombres taxonómicos científicos o vulgares."},
	tourTitle10: { "en": "More options",
		"es": "Más opciones"},
	tourText10: { "en": "Push to go to the landing page or to change the language.",
		"es": "Pulsa para ir a la página de inicio o para cambiar el idioma."},	
	tourTitle11: { "en": "Configure a plot filter",
		"es": "Configura un filtro de parcela"},
	tourText11: { "en": "Define the desired stock ranges for the plots.",
		"es": "Define los rangos de existencias deseados para las parcelas."},
	tourTitle12: { "en": "Taxon information",
		"es": "Información de taxón"},
	tourText12: { "en": "Get taxon information.",
		"es": "Obtén información del taxón."},
	tourTitle13: { "en": "Taxon color",
		"es": "Color de taxón"},
	tourText13: { "en": "Select the color of the taxon.",
		"es": "Elige el color del taxón."},
	tourTitle14: { "en": "Remove taxon",
		"es": "Quitar taxón"},
	tourText14: { "en": "Remove a filter taxon.",
		"es": "Elimina un filtro de taxón."},
	tourTitle15: { "en": "The end",
		"es": "Hemos terminado"},
	tourText15: { "en": "That\'s all for now.<br>Enjoy Forest Explorer!",
		"es": "Esto es todo por ahora.<br>¡Disfruta el Explorador Forestal!"},
	tourExit: { "en": "Exit",
		"es": "Salir"},
	tourNext: { "en": "Next",
		"es": "Siguiente"},
	tourBack: { "en": "Back",
		"es": "Atrás"},
	tourDone: { "en": "Done",
		"es": "Hecho"}		
}